import { toast } from "@carbon6/c6-frontend-design";
import { useEffect, useRef, type ReactNode } from "react";
import { useNavigate, useParams } from "react-router";
import { getAnnotationSet } from "@/api";
import { openDatasetDetailWindow } from "@/app/datasetDetailWindow";

/**
 * `/annotation/sets/{uuid}` 딥링크. 셋을 조회해 소속 Dataset(dataset_uuid)을 찾는다. 그리고
 * 그 데이터셋 상세 창을 **어노테이션 탭 + 셋 로드** 상태로 연다. 창은 라우트 밖(app-level)에
 * 있으므로 이 페이지는 창을 열고 바로 데이터셋 목록으로 이동한다.
 */
export function AnnotationSetDeepLinkPage(): ReactNode {
  const { setUuid } = useParams<{ setUuid: string }>();
  const navigate = useNavigate();
  // StrictMode 이중 마운트에서 창을 두 번 열지 않는다.
  const openedRef = useRef(false);

  useEffect(() => {
    if (setUuid === undefined || openedRef.current) {
      return;
    }
    openedRef.current = true;

    void getAnnotationSet(setUuid)
      .then((set) => {
        openDatasetDetailWindow({
          datasetUuid: set.dataset_uuid,
          // 데이터셋을 적재한 뒤 창 제목을 display_name 으로 바꾼다. 셋 이름은 임시 제목이다.
          displayName: set.name ?? "Annotation Set",
          initialTab: "annotation",
          annotationSetUuid: set.uuid,
        });
      })
      .catch(() => {
        toast.error("Annotation Set을 찾을 수 없습니다. 링크가 오래됐을 수 있습니다.");
      })
      .finally(() => {
        navigate("/datasets", { replace: true });
      });
  }, [setUuid, navigate]);

  return null;
}
